
import { defineComponent, watch } from 'vue';

export default defineComponent({
	props: {
		show: {
			required: true,
			type: Boolean,
		},
		isSuccess: {
			required: true,
			type: Boolean,
		},
	},
	setup(props, { emit }) {
		watch(
			() => props.show,
			newValue => {
				if (newValue) {
					setTimeout(() => emit('update:show', false), 5000);
				}
			}
		);
	},
});
